function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 13.092C8 8.61441 11.6144 5 16.092 5C20.5695 5 24.1839 8.61441 24.1839 13.092C24.1839 18.4866 16.092 26.5785 16.092 26.5785C16.092 26.5785 8 18.4866 8 13.092ZM21.4866 13.092C21.4866 10.1249 19.086 7.69732 16.092 7.69732C13.1249 7.69732 10.6973 10.1249 10.6973 13.092C10.6973 16.086 13.1249 18.4866 16.092 18.4866C19.086 18.4866 21.4866 16.086 21.4866 13.092Z",
  fill: "#212B36"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 8,
  y: 5,
  width: 17,
  height: 22
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 13.092C8 8.61441 11.6144 5 16.092 5C20.5695 5 24.1839 8.61441 24.1839 13.092C24.1839 18.4866 16.092 26.5785 16.092 26.5785C16.092 26.5785 8 18.4866 8 13.092ZM21.4866 13.092C21.4866 10.1249 19.086 7.69732 16.092 7.69732C13.1249 7.69732 10.6973 10.1249 10.6973 13.092C10.6973 16.086 13.1249 18.4866 16.092 18.4866C19.086 18.4866 21.4866 16.086 21.4866 13.092Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.eba534db.svg";
export { ForwardRef as ReactComponent };